<script>
import { breakpointsMixin } from '../../mixins/breakpointsMixin'
import NewSubscriptionChoose from '@components/NewSubscriptionChoose.vue'
import { fontMixin } from '../../mixins/fontMixin'
import { colorMixin } from '../../mixins/colorMixin'
import { mapState } from 'vuex'
import Translate from '../translate'

export default {
  props: {
    component: Object
  },
  components: {
    NewSubscriptionChoose,
    Translate
  },
  mixins: [breakpointsMixin, fontMixin, colorMixin],
  data () {
    return {}
  },
  created () {
    this.$_addFont(this.componentFont)
  },
  computed: {
    ...mapState(['trialDays']),
    componentFont () {
      return (
        this.component && this.component.fontSetup && this.component.fontSetup.font &&
          this.component.fontSetup.font.fontFamily
      )
    }
  }
}
</script>

<template v-if="component">
  <section
    class="pricing-block"
    id="register"
    :style="{
      '--background-color': $_rgba(component.backgroundColor, 1),
      '--fontFamily': 'Nunito Sans',
      }"
  >
    <div class="subscription-container">
      <div class="mh-100" align-v="center">
        <div>
          <div class="subscriptionChoose">
            <NewSubscriptionChoose :component="component"/>
          </div>
          <div class="secure-checkout-wrapper">
            <div class="text-with-image">
              <img class="lock" width="18" height="26" src="../../../public/lock.svg" alt="lock">
              <p class="secure-checkout">SECURE CHECKOUT</p>
            </div>
            <div class="checkout-options">
              <img class="pay-card" width="70" height="48" src="../../../public/Visa.svg" alt="visa">
              <img class="pay-card" width="70" height="48" src="../../../public/Mastercard.svg" alt="mastercard">
              <img class="pay-card" width="70" height="48" src="../../../public/applepay.svg" alt="apple pay">
              <img class="pay-card" width="70" height="48" src="../../../public/googlepay.svg" alt="google pay">
            </div>
          </div>
          <p class="fine-print">
            <Translate
              directive="checkout.disclaimer1"
              v-if="trialDays"
              :dynamicContent="{trialDays: trialDays}"
            />
            <Translate directive="checkout.disclaimer2" />
            <Translate directive="checkout.disclaimer3" />
            <router-link class="link" to="/tos"><Translate directive="checkout.disclaimer3.tos" /></router-link>
            <Translate directive="checkout.disclaimer3.and" />
            <router-link class="link" to="/privacy"><Translate directive="checkout.disclaimer3.privacy" /></router-link>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@design';
  .container {
    height: 100%;
  }
  .subscriptionChoose {
    width: 100%;
  }
  .subscription-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .fine-print {
    line-height: 1.5 !important;
    text-align: center;
    color: #767676;
    max-width: 624px;
    width: 100%;
    margin: 0 auto;
    margin-top: 30px;
    font-weight: normal !important;
    font-size: 16px !important;
    .link {
      line-height: 1.5 !important;
      text-align: center;
      color: #767676;
      max-width: 624px;
      width: 100%;
      margin: 0 auto;
      margin-top: 30px;
      font-weight: normal !important;
      font-size: 16px !important;
      text-decoration: none;
    }
  }

  .pricing-block {
    -webkit-font-smoothing: antialiased;
    line-height: 1.5;
    font-family: var(--fontFamily);
    width: 100vw;
    display: flex;
    position: relative;
    background-color: var(--background-color);
    min-height: 50rem;
    align-items: center;
    justify-content: center;
    #plan-container {
      display: flex;
      align-items: center;
      justify-content: center;
      .signup-arrow {
        transition-timing-function: ease;
        z-index: 8;
        margin-top: 15px;
        svg {
          color: black;
          float: right;
          margin-right: 30px;
          margin-top: -9px;
          border-radius: 3px;
          border-style: solid;
          border-width: 2px;
          width: 40px;
          background-color: white;
          border-color: rgb(175, 175, 175);
          cursor: pointer;
          &:hover { background-color: gray;}
        }
      }
      .signup-popover-enter {
        opacity: 0;
        transform: rotateY(90deg);
      }
      .signup-popover-enter-to {
        opacity: 1;
        transform: rotateY(0deg);
      }
      .signup-popover-enter-active {
        transition: opacity, transform 400ms ease-out;
      }
      .signup-popover-leave-active {
        transition: opacity 300ms ease-in;
      }
      .signup-popover-leave-to {
        opacity: 0;
      }
      .card-popover-enter {
        opacity: 0;
        transform: rotateY(90deg);
      }
      .card-popover-enter-to {
        opacity: 1;
        transform: rotateY(0deg);
      }
      .card-popover-enter-active {
        transition: opacity, transform 400ms ease-out;
      }
      .card-popover-leave-active {
        transition: opacity 300ms ease-in;
      }
      .card-popover-leave-to {
        opacity: 0;
      }
      .sign-up {
        flex-direction: column;
        display: inline-flex;
        justify-content: space-between;
        padding: 10px;
        width: 100%;
        .signup-email {
          outline: 0;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          padding: 4px 8px;
          border-radius: 3px;
          color: #fff;
          border-radius:8px;
          width: 100%;
          height: 40px;
          margin-top: 2.5px;
          margin-bottom: 2.5px;
          text-transform: none;
          cursor: pointer;
          svg {
            margin-right: 5px;
          }
          &:disabled { cursor: not-allowed }
        }
      }
      .pay {
        outline: 0;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 4px 8px;
        border-radius: 3px;
        background-color: var(--secondary-color);
        color: #fff;
        border-radius:8px;
        width: 160px;
        height: 40px;
        margin-top: 2.5px;
        margin-bottom: 2.5px;
        cursor: pointer;
        svg {
          margin-right: 5px;
        }
        &:hover {
          background-color: var(--primary-color);
          &:disabled { cursor: not-allowed; background-color: var(--secondary-color);}
        }
      }
      .signup-form {
        margin: 10px;
        padding: 1rem;
        height: fit-content;
        border-radius: 20px;
        background-color: white;
        width: 400px;
        p { font-weight: bold; font-size: 1.2rem;}
      }
      @media (max-width: 992px) {
        flex-direction: column-reverse;
        .subscriptionChoose { width: -webkit-fill-available; padding: 1rem; }
        .signup-form { width: 350px; }
      }
      @media screen and (max-width:768px){
        background:#fff;
      }
    }
    .secure-checkout-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 48px;
      margin-bottom: 24px;
      .text-with-image {
        display: flex;
        align-items: center;
        margin-right: 24px;

        .secure-checkout {
          margin-bottom: 0;
          margin-left: 12px;
          color: #222222;
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
        }
      }
      .checkout-options {
        display: flex;
        flex-wrap: wrap;

        .pay-card + .pay-card {
          margin-left: 16px;
        }
      }

      @media screen and (max-width:768px){
        flex-direction: column;
        .text-with-image {
          margin-right: 0;
        }
        .pay-card {
          margin-top: 24px;
        }
      }
    }
  }
</style>
